import { applyTransform2Object } from '@bit/gerenciatd.utils.common';
import FrontSonda from '@bit/gerenciatd.utils.front-sonda';

export const processName = 'ADABYRON-API';
export const processNameTges = `${processName}-TGES`;
export const processNameOpen = `${processName}-OPEN`;

export enum USER_TYPES {
  CLIENT = 'Telco',
  TGES = 'Gestor',
  OPEN = '',
}

export const isRedirectToLoginError = (responseUrl: string): boolean => {
  if (responseUrl && responseUrl.indexOf('DesafioUnico') !== -1) {
    return true;
  }
  return false;
};

export const normalizeRedirectError = (responseUrl: string): string => {
  const urlActual = window.location.href;

  if (window.location.hostname === 'www.movistar.es') {
    // eslint-disable-next-line max-len
    return `https://www.movistar.es/mimovistar-cliente/publico/servicio/login?urlContenedora=${responseUrl}&urlDestino=${encodeURIComponent(
      urlActual,
    )}`;
  }
  if (window.location.hostname === 'www.movistar.es.cert') {
    // eslint-disable-next-line max-len
    return `https://www.movistar.es.cert/mimovistar-cliente/publico/servicio/login?urlContenedora=${responseUrl}&urlDestino=${encodeURIComponent(
      urlActual,
    )}`;
  }
  if (window.location.hostname === 'www.movistar.es.inte') {
    // eslint-disable-next-line max-len
    return `https://www.movistar.es.inte/mimovistar-cliente/publico/servicio/login?urlContenedora=${responseUrl}&urlDestino=${encodeURIComponent(
      urlActual,
    )}`;
  }
  return '#';
};

export const makeLoginRedirect = (responseUrl: string): void => {
  window.location.href = normalizeRedirectError(responseUrl);
};

export const makeUndefinedValueNull = (
  obj: Record<string, unknown>,
): Record<string, unknown> => {
  return applyTransform2Object(
    [
      {
        type: 'undefined',
        method: () => null,
      },
    ],
    (key) => key,
    obj,
  );
};

export const getMethodNotAllowedReject = (path: string): Promise<any> => {
  return Promise.reject({
    status: 418,
    statusText: "I'm a teapot",
    response: `Method not allowed for this type of user: ${path}`,
  });
};

export const getTelcoHost = (
  context: any,
  path: string,
  userTypesAllowed: string[],
  version?: number,
): {
  endpoint: string;
  headers: any;
  processName: string;
  allowed: boolean;
} => {
  try {
    const { environment, userType } = context;

    if (userTypesAllowed.includes(userType)) {
      let { telco: connectionData } = environment;
      let prefixToApply = '/cliente/api/';
      let finalProcessName = processName;

      if (userType === USER_TYPES.TGES) {
        ({ tges: connectionData } = environment);
        prefixToApply = '';
        finalProcessName = processNameTges;
      }
      if (userType === USER_TYPES.OPEN) {
        prefixToApply = '/abierto/api/';
        finalProcessName = processNameOpen;
      }

      const { endpoint: host, headers } = connectionData;
      const pathBegin = path.substr(0, path.indexOf('/'));
      const pathEnd = path.substr(path.indexOf('/') + 1, path.length);
      let finalEndpoint = `${host}${prefixToApply}${pathBegin}/`;
      if (version) {
        finalEndpoint = `${finalEndpoint}v${version}/`;
      }

      return {
        endpoint: `${finalEndpoint}${pathEnd}`,
        headers,
        processName: finalProcessName,
        allowed: true,
      };
    } else {
      return {
        endpoint: '',
        headers: {},
        processName: '',
        allowed: false,
      };
    }
  } catch (error) {
    console.error(error);
    const frontSonda = new FrontSonda({
      processName: 'getTelcoHost',
      context,
      filePath: 'utils/ada-byron',
    });
    frontSonda.errorMessage({ info: `error on path ${path}`, error });
  }
  return null;
};

export const normalizeObjError = (
  xhr,
  context: any,
): {
  status: number;
  statusText: string;
  response: Record<string, unknown> | string;
} => {
  const objError = {
    status: xhr.status,
    statusText: xhr.statusText,
    response: null,
  };

  if (objError.status === 401 || objError.status === 400) {
    const { userType } = context;
    if (userType === USER_TYPES.TGES) {
      window.location.href = `${context.environment.tges.endpoint}autorizacion/acceso`;
    }
  }
  try {
    objError.response = JSON.parse(xhr.response);
  } catch (error) {
    objError.response = xhr.response;
  }

  return objError;
};
